
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/event-protection",
      function () {
        return require("private-next-pages/event-protection/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/event-protection"])
      });
    }
  